export default "__VITE_ASSET__DoFaV8kR__"